<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-08-09 15:31:34
 * @LastEditTime: 2023-07-04 14:03:52
 * @LastEditors: cxh
-->
<template>
  <div class="cos-form-item-detail cos-form-item-input-detail" v-if="view">
    <p>{{ valueFormat || '--' }}</p>
  </div>
  <span v-else :title="titleFormat">{{ valueFormat }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getTreeNameList } from '@/utils'
import useHook from './useHook'

const props = defineProps<{
  appId: 'cos_fbu' | 'cos_ofbu' | 'cos_lbu'
  value?: string | [] | null
  view?: boolean
  multiple?: boolean // 是否多选
  lastLeval?: boolean // 是否只展示最后一级
}>()
const { customerLabelEnum } = useHook(props.appId)

const valueFormat = computed(() => {
  if (props.value == null) return '--'
  const config = props.appId === 'cos_lbu' ? { label: 'name' } : { label: 'label' }
  if (props.multiple) {
    const labelArray: any = []
    if (props.value && Array.isArray(props.value)) {
      props.value.forEach((val) => {
        const labelList = getTreeNameList(customerLabelEnum.value, val, config).filter((name) => name)
        if (props.lastLeval && labelList?.length) {
          labelArray.push(labelList[labelList.length - 1])
        } else {
          labelArray.push(labelList.join('/'))
        }
      })
    }
    return labelArray.join(';') || '--'
  } else {
    const labelList = getTreeNameList(customerLabelEnum.value, props.value, config).filter((name) => name)
    return labelList.join('/') || '--'
  }
})
const titleFormat = computed(() => {
  return valueFormat.value === '--' ? '' : valueFormat.value
})
</script>
<script lang="ts">
export default { name: 'CustomerLabelCascaderText' }
</script>

<style scoped></style>
